export default Object.freeze([
    { value: "InOffice", label: "In-Office or On-Site", trackingId: "InOffice", description: "Full Time at an Office Workspace" },
    { value: "Hybrid", label: "Hybrid", trackingId: "Hybrid", description: "A Mix of In-Office and Remote" },
    { value: "Remote", label: "Remote", trackingId: "Remote", description: "Full time at a Remote Workspace" }
]);